module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei6.svg";